<app-data-filters [fullWidth]="true" [opened]="true" [disableSearch]="disableSearch" #dataFilters>
    <app-data-filter-group *ngIf="!isCarrier" [useAvailableWidth]="true" [flexDirection]="'row'">
        <app-data-filter-group class="data-filter" [labelKey]="'pods-validation.filters.regions.label'">
            <ng-select style="flex: 1"
                       [items]="availableRegions"
                       [bindValue]="'value'"
                       [multiple]="true"
                       [i18n]="[{target: 'attribute:placeholder', key: 'pods-validation.filters.regions.placeholder'}]"
                       [placeholder]="'pods-validation.filters.regions.placeholder' | translate"
                       [(ngModel)]="filters.regions"
                       (ngModelChange)="regionsChanged()">
            </ng-select>
        </app-data-filter-group>

        <app-data-filter-group class="data-filter" [labelKey]="'pods-validation.filters.carriers.label'">
            <ng-select style="flex: 1"
                       [items]="availableCarriers"
                       [bindValue]="'value'"
                       [multiple]="true"
                       [i18n]="[{target: 'attribute:placeholder', key: 'pods-validation.filters.carriers.placeholder'}]"
                       [placeholder]="'pods-validation.filters.carriers.placeholder' | translate"
                       [(ngModel)]="filters.carriers"
                       (ngModelChange)="carrierChanged()">
            </ng-select>
        </app-data-filter-group>
    </app-data-filter-group>

    <app-data-filter-group [useAvailableWidth]="true">
        <app-data-filter-multi-string-input [labelKey]="'pods-validation.filters.load-delivery-numbers.label'"
                                            [placeholderKey]="'pods-validation.filters.load-delivery-numbers.placeholder'"
                                            [(model)]="filters.loadOrDeliveryNumbers"
                                            [separators]="[' ',',',';']"
                                            (modelChange)="filtersChanged()">
        </app-data-filter-multi-string-input>

        <app-data-filter-select [labelKey]="'pods-validation.filters.type.label'"
                                [(model)]="filters.type"
                                [options]="typeOptions"
                                (modelChange)="filtersChanged()">
        </app-data-filter-select>
    </app-data-filter-group>

    <app-data-filter-group [useAvailableWidth]="true">
        <app-data-filter-multi-string-input [labelKey]="'pods-validation.filters.origin.label-new'"
                                            [placeholderKey]="'pods-validation.filters.origin.placeholder'"
                                            [(model)]="filters.originGlid"
                                            [separators]="[' ',',',';']"
                                            (modelChange)="filtersChanged()">
        </app-data-filter-multi-string-input>

        <app-data-filter-multi-string-input [labelKey]="'pods-validation.filters.destination.label'"
                                            [placeholderKey]="'pods-validation.filters.destination.placeholder'"
                                            [(model)]="filters.destinationGlid"
                                            [separators]="[' ',',',';']"
                                            (modelChange)="filtersChanged()">
        </app-data-filter-multi-string-input>
    </app-data-filter-group>

    <app-data-filter-group [useAvailableWidth]="true" [spaceAuto]="true">

        <app-data-filter-group class="data-filter minimal-label" [useAvailableWidth]="true" [labelKey]="'pods-validation.filters.pod-upload-date.label'">
            <app-data-filter-date [labelKey]="'pods-validation.filters.pod-upload-date.between'"
                                  [maxDate]="filters.podUploadedBefore"
                                  [(model)]="filters.podUploadedAfter"
                                  (modelChange)="filtersChanged()">
            </app-data-filter-date>

            <app-data-filter-date [labelKey]="'pods-validation.filters.pod-upload-date.and'"
                                  [minDate]="filters.podUploadedAfter"
                                  [(model)]="filters.podUploadedBefore"
                                  (modelChange)="filtersChanged()">
            </app-data-filter-date>
        </app-data-filter-group>

        <app-data-filter-group class="data-filter minimal-label" [useAvailableWidth]="true" [labelKey]="'pods-validation.filters.pod-delivery-date.label'">
            <app-data-filter-date [labelKey]="'pods-validation.filters.pod-upload-date.between'"
                                  [maxDate]="filters.deliveryDateBefore"
                                  [(model)]="filters.deliveryDateAfter"
                                  (modelChange)="filtersChanged()">
            </app-data-filter-date>

            <app-data-filter-date [labelKey]="'pods-validation.filters.pod-upload-date.and'"
                                  [minDate]="filters.deliveryDateAfter"
                                  [(model)]="filters.deliveryDateBefore"
                                  (modelChange)="filtersChanged()">
            </app-data-filter-date>
        </app-data-filter-group>

    </app-data-filter-group>

    <app-data-filter-group class="data-filter" [useAvailableWidth]="true">
        <app-data-filter-switch class="data-filter-switch"
                                [labelKey]="'pods-validation.filters.only-rejected.label'"
                                [(model)]="filters.onlyRejected"
                                (modelChange)="filtersChanged()">
        </app-data-filter-switch>
    </app-data-filter-group>

    <app-data-filters-button *ngIf="displaySendReminderButton"
                             [labelKey]="'pods-validation.filters.reminder'"
                             [type]="'primary'"
                             (onClick)="sendReminder.emit()">
        <i class="fa fa-paper-plane"></i>
    </app-data-filters-button>

    <app-data-filters-button *ngIf="displayExportButton"
                             [labelKey]="'pods-validation.filters.export'"
                             [type]="'primary'"
                             (onClick)="export.emit()">
        <i class="fa fa-download"></i>
    </app-data-filters-button>
</app-data-filters>
